import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

export interface ISidebarObfuscatorProps {
    onClick(event: React.MouseEvent<HTMLDivElement>): void;
    readonly active: boolean;
}

@observer
export class SidebarObfuscator extends React.Component<ISidebarObfuscatorProps> {
    public render() {
        return <div className={this.getClassName} onClick={this.props.onClick} />;
    }

    @computed
    private get getClassName() {
        let className = 'sidebar-layout-obfuscator';

        if (this.props.active) {
            className += ' active';
        }

        return className;
    }
}
